import { useContext, useEffect, useState } from 'react';
import { downtimeContext } from "../contexts/downtimeContext.js";
import { fetchNotices } from "../functions/fetchNotices.js";
export const useNotices = visibility => {
  const {
    polling
  } = useContext(downtimeContext);
  const [loading, setLoading] = useState(false);
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    const fn = async () => {
      setLoading(true);
      const notices = await fetchNotices(visibility === 'PUBLIC');
      setNotices(notices);
      setLoading(false);
    };
    void fn();
  }, [polling, visibility]);
  return {
    notices,
    loading
  };
};